import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { ChangeLogTypeEnum, UpdatesStore } from '../../@store/updates';
import { AuthStore } from '../../@store';

@Component({
  selector: 'app-updates',
  templateUrl: './updates.component.html',
  styleUrls: ['./updates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdatesComponent implements OnInit {
  readonly changeLogTypeEnum = ChangeLogTypeEnum;

  activeTab = ChangeLogTypeEnum.ViGuide;

  constructor(public updatesStore: UpdatesStore, public authStore: AuthStore) {}

  ngOnInit(): void {
    this.updatesStore.fetchViGuideUpdates();
    this.updatesStore.fetchViCareUpdates();
  }

  onTabChanged(type: ChangeLogTypeEnum): void {
    this.activeTab = type;
  }
}
